import { handleActions } from 'redux-actions';
import * as dashboardActions from './dashboard-actions';
import {
  DashboardStateFactory,
  PermitContextFactory,
} from './dashboard-constants';

export const dashboardReducer = handleActions<
  ReturnType<typeof DashboardStateFactory>,
  /**
   * "handleActions" expects a singular payload type.
   * However, we need to support more than one.
   * That's why we narrow it down per action.
   */
  any // eslint-disable-line @typescript-eslint/no-explicit-any
>(
  {
    [dashboardActions.setSidebarItems.type]: (
      state,
      action: ReturnType<typeof dashboardActions.setSidebarItems>
    ) => {
      return state.set('selectedSidebarItems', action.payload.items);
    },

    [dashboardActions.setDashboardReady.type]: (
      state,
      action: ReturnType<typeof dashboardActions.setDashboardReady>
    ) => {
      return state.set('dashboardReady', action.payload.dashboardReady);
    },

    [dashboardActions.toggleUniversalSearch.type]: (
      state,
      action: ReturnType<typeof dashboardActions.toggleUniversalSearch>
    ) => {
      return state.set(
        'isUniversalSearchActive',
        action.payload.isUniversalSearchActive
      );
    },

    [dashboardActions.setActivePropertyDetailsTab.type]: (
      state,
      action: ReturnType<typeof dashboardActions.setActivePropertyDetailsTab>
    ) => {
      return state.set('activePropertyDetailsTab', action.payload.activeTab);
    },

    [dashboardActions.setLoadingText.type]: (
      state,
      action: ReturnType<typeof dashboardActions.setLoadingText>
    ) => {
      return state.set('loadingText', action.payload.loadingText);
    },

    [dashboardActions.clearPermitContextRecord.type]: (state) => {
      return state.set('permitContext', new PermitContextFactory());
    },

    [dashboardActions.updatePermitContextRecordItem.type]: (
      state,
      action: ReturnType<typeof dashboardActions.updatePermitContextRecordItem>
    ) => {
      /** Both "state" and "permitContext" are Immutable Records. */
      return state.set(
        'permitContext',
        state
          .get('permitContext')
          .set(action.payload.field, action.payload.value)
      );
    },
  },
  new DashboardStateFactory()
);
